// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Loading_spinnerContainer__2v-Ji","spinner":"Loading_spinner__1ctAv","loading":"Loading_loading__2JaUi","logo":"Loading_logo__1fOEv"};